import React from "react";
import { useCurrentFrame, interpolate, spring, useVideoConfig } from "remotion";

interface HookCardProps {
  text: string;
  fontSize?: number;
  accentColor?: string;
  durationFrames?: number;
}

/**
 * Bold opening card shown in the first 1-2 seconds of a clip.
 * Grabs attention with large text and a quick animation.
 */
export const HookCard: React.FC<HookCardProps> = ({
  text,
  fontSize = 52,
  accentColor = "#F37021",
  durationFrames = 60,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Fast entrance spring
  const enterProgress = spring({
    frame,
    fps,
    config: { damping: 14, stiffness: 200 },
  });

  // Exit at end of duration
  const exitStart = durationFrames - 15;
  const exitOpacity = interpolate(
    frame,
    [exitStart, durationFrames],
    [1, 0],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  const scale = interpolate(enterProgress, [0, 1], [1.1, 1]);
  const opacity = enterProgress * exitOpacity;
  const translateY = interpolate(enterProgress, [0, 1], [-20, 0]);

  // Accent underline grows in
  const underlineWidth = interpolate(
    frame,
    [8, 25],
    [0, 100],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        opacity,
        transform: `scale(${scale}) translateY(${translateY}px)`,
        padding: "40px 60px",
      }}
    >
      <div
        style={{
          fontSize,
          fontFamily: "'Playfair Display', serif",
          fontWeight: 700,
          color: "#FFFFFF",
          textAlign: "center",
          lineHeight: 1.3,
          maxWidth: "90%",
          textShadow: "0 2px 20px rgba(0,0,0,0.5)",
        }}
      >
        {text}
      </div>
      <div
        style={{
          width: `${underlineWidth}px`,
          height: 3,
          backgroundColor: accentColor,
          marginTop: 16,
          borderRadius: 2,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
